import { api } from './client'

export interface BillingAccount {
  id: string
  name: string
  status:
    | 'trialing'
    | 'active'
    | 'past_due'
    | 'canceled'
    | 'incomplete'
    | 'unpaid'
  trial_ends_at: number | null
  trial_credits_usd: number
  trial_spent_usd: number
  period_spent_usd: number
  workspaces: string[]
  has_subscription: boolean
}

export async function listBillingAccounts(): Promise<BillingAccount[]> {
  return api.get('/api/billing/accounts')
}

export async function createBillingAccount(
  name: string,
): Promise<BillingAccount> {
  return api.post('/api/billing/accounts', { name })
}

export async function getBillingAccount(id: string): Promise<BillingAccount> {
  return api.get(`/api/billing/accounts/${id}`)
}

export async function linkWorkspace(
  accountId: string,
  workspaceId: string,
): Promise<void> {
  return api.post(`/api/billing/accounts/${accountId}/workspaces`, {
    workspace_id: workspaceId,
  })
}

export async function createCheckoutSession(
  accountId: string,
): Promise<{ url: string }> {
  return api.post(`/api/billing/accounts/${accountId}/checkout`, {})
}

export async function createPortalSession(
  accountId: string,
): Promise<{ url: string }> {
  return api.post(`/api/billing/accounts/${accountId}/portal`, {})
}
